import HeaderSettings from './HeaderSettings';

import './HeaderSettings.scss';

export default HeaderSettings;
